import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { combineLatest, debounceTime, skipWhile, Subscription, take } from 'rxjs';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { emailValidator, importeMayorACeroValidator } from '../../@validators/validators-complemento';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';
import { ConsultaComplementoGeneralOutput, ConsultaDireccionOutput, ConsultaSiniestroOutput, FechasAtencion } from 'src/app/models/complementos-web/complementos-web.model';
import moment from 'moment';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatCard } from '@angular/material/card';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';

@Component({
    selector: 'app-crear-actualiza-complemento',
    templateUrl: './crear-actualiza-complemento.component.html',
    styleUrls: ['./crear-actualiza-complemento.component.scss'],
    imports: [MatCard, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatError, NgClass, MatInput, MatIcon, MatSuffix, MatMenuTrigger, OnlyNumber, FormatoNumeroMonedaCoplementoWebDirective, UpperCaseTextDirective, MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatMenu]
})
export class CrearActualizaComplementoComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() public detalleComplementoSiniestro: ConsultaComplementoGeneralOutput;

  @Output() eventosActualizaComplemento = new EventEmitter<{ nombre: string, valor: any }>();

  public formActualizaComplemento: FormGroup;
  public causaSIniestro: number = 1;

  public responsables = [
    { id: 1, nombre: 'ASEGURADO' },
    { id: 2, nombre: 'TERCERO' },
    { id: 3, nombre: 'CORRRESPONSABILIDAD' },
  ];
  public sexos = [];
  public preexistentes = [
    { id: 1, nombre: 'SI' },
    { id: 2, nombre: 'NO' }
  ];
  public tipoUbicaciones = [];
  public subUbicaciones = [];
  public perdidas = [];
  public subCausas = [];
  public paises = [];
  public estados = [];
  public municipios = [];
  public tipoEstimaciones = [];

  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public coberturasComplemento: any[];

  public cesvi = { estatus_cesvi: 0, error_serie: "", intento: 0, error_digitos: 0 };
  public banderasFechas = {
    fechaInicio: false,
    mostrarHoraInicio: false,
    fechaFin: false,
    mostrarHoraTermino: false
  }
  public mostrarSeccionInicio = false;
  public mostrarSeccionTermino = false;
  public verificaSerieHTML = '';
  public verificaSerieHTMLSa;
  public serieInvalida = false;
  public horas = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  public minutos = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  public listaObservables: Array<Subscription> = [];

  constructor(
    private store: Store<AppState>,
    private complementoService: ComplementoWebService,
    private procesosComplementoService: ProcesosComunesComplementoService,
    private sanitizer: DomSanitizer
  ) {
    this.onReduxChange();
    this.crearFormulario();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["detalleComplementoSiniestro"]?.currentValue) {
      this.coberturasComplemento = changes["detalleComplementoSiniestro"]?.currentValue?.Coberturas ?? [];
      this.setFormulario();
    }
  }

  ngAfterViewInit(): void {
    this.configuraFormulario();
  }

  ngOnInit(): void {
    this.cambiosFormulario();
  }

  onReduxChange() {
    combineLatest([
      this.store.select(selectListaCatalogosSiniestros).pipe(take(1)),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null))
    ]).subscribe(([catalogos, detalleCompleto, detalleBase]) => {
      this.sexos = catalogos.consultaSexo;
      this.subUbicaciones = catalogos.consultaSubtipoUbicaciones;
      this.tipoUbicaciones = catalogos.consultaTipoUbicaciones;
      this.tipoEstimaciones = catalogos.consultaTipoEstimacion;
      this.perdidas = catalogos.consultaTipoPerdida;
      this.paises = catalogos.consultaPaises;

      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;

    });
  }

  crearFormulario() {
    this.formActualizaComplemento = new FormGroup({
      responsable: new FormControl(''),
      kilometraje: new FormControl(''),
      serie: new FormControl('', [Validators.min(17)]),
      edadConductor: new FormControl('', [importeMayorACeroValidator()]),
      sexoConductor: new FormControl('', [importeMayorACeroValidator(), Validators.required]),
      email: new FormControl('', [emailValidator(), Validators.email]),
      estimacionDanos: new FormControl(''),
      corralonDestino: new FormControl(''),
      preexistentes: new FormControl('', [Validators.required, importeMayorACeroValidator()]),
      tipoUbicacion: new FormControl('', [Validators.required, importeMayorACeroValidator()]),
      subUbicacion: new FormControl(''),
      tipoPerdida: new FormControl('', [Validators.required, , importeMayorACeroValidator()]),
      subCausa: new FormControl('', [Validators.required, importeMayorACeroValidator()]),
      importe: new FormControl(''),

      pais: new FormControl(null),
      estado: new FormControl(null),
      cp: new FormControl(''),
      colonia: new FormControl(''),
      municipio: new FormControl(null),
      calle: new FormControl(''),
      referencias: new FormControl(''),
      fechaRegistro: new FormControl({ value: null, disabled: true }),
      numeroParticipantes: new FormControl(null),
      tipoRobo: new FormControl({ value: null, disabled: true }),
      fechaRobo: new FormControl({ value: null, disabled: true }),
      numeroActa: new FormControl(''),
      ocra: new FormControl(0),
      participantes: new FormControl(0),

      inicioFechaAtencion: new FormControl(null),
      inicioHoraAtencion: new FormControl(null),
      inicioMinutoAtencion: new FormControl(null),

      finFechaAtencion: new FormControl(null),
      finHoraAtencion: new FormControl(null),
      finMinutoAtencion: new FormControl(null),
    })
  }

  configuraFormulario() {
    let validaTercero = false;
    let validaCausa = false;
    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    const responsabilidad = this.detalleSiniestroCompleto?.Siniestro[0].respons_sini;
    const causa = this.detalleSiniestroCompleto?.Siniestro[0].causa;
    const sucursal = this.detalleSiniestroCompleto?.Siniestro[0].sucursalk1;
    const serieAdmin = this.detalleSiniestroCompleto?.Siniestro[0].serie_admin;
    const serieNormal = this.detalleSiniestroCompleto?.Siniestro[0].serie_normal == null ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].serie_normal;

    this.obtenerSubCausas(causa);

    if (perfilAdministrador == 0 && [3, 6].includes(causa)) {
      validaCausa = true;
      this.formActualizaComplemento.get("responsable").disable({ emitEvent: false });
      this.formActualizaComplemento.get("fechaRobo").enable({ emitEvent: false });
      this.formActualizaComplemento.get("fechaRegistro").enable({ emitEvent: false });
    }

    if (serieNormal == 0 && perfilAdministrador == 0 && [3, 6].includes(causa)) {
      this.formActualizaComplemento.get("responsable").setValue(2);
    }

    if (perfilAdministrador == 0 && serieAdmin != 1) {
      this.formActualizaComplemento.get("serie").setValidators(Validators.required);
      this.formActualizaComplemento.get("serie").updateValueAndValidity();
    }

    if (this.detalleSiniestroCompleto?.["FechasAtencion"]?.length) {
      this.procesarVariablesFechas(perfilAdministrador, this.detalleSiniestroCompleto?.["FechasAtencion"]);
    } else {
      this.banderasFechas = {
        fechaInicio: false,
        fechaFin: false,
        mostrarHoraInicio: false,
        mostrarHoraTermino: false
      };
      this.formActualizaComplemento.get("inicioFechaAtencion").setValidators(null);
      this.formActualizaComplemento.get("inicioFechaAtencion").updateValueAndValidity();
      this.formActualizaComplemento.get("finFechaAtencion").setValidators(null);
      this.formActualizaComplemento.get("finFechaAtencion").updateValueAndValidity();
      this.formActualizaComplemento.get("inicioHoraAtencion").setValidators(null);
      this.formActualizaComplemento.get("inicioHoraAtencion").updateValueAndValidity();
      this.formActualizaComplemento.get("inicioMinutoAtencion").setValidators(null);
      this.formActualizaComplemento.get("inicioMinutoAtencion").updateValueAndValidity();
      this.formActualizaComplemento.get("finHoraAtencion").setValidators(null);
      this.formActualizaComplemento.get("finHoraAtencion").updateValueAndValidity();
      this.formActualizaComplemento.get("finMinutoAtencion").setValidators(null);
      this.formActualizaComplemento.get("finMinutoAtencion").updateValueAndValidity();
    }

    if (perfilAdministrador == 0 && serieAdmin == 1) {
      this.formActualizaComplemento.get("serie").disable({ emitEvent: false })
    } else {
      this.formActualizaComplemento.get("serie").enable({ emitEvent: false });
      this.formActualizaComplemento.get("serie").setValidators(Validators.required);
      this.formActualizaComplemento.get("serie").updateValueAndValidity();
    }

    if (['DB7', 'DBA',].includes(sucursal) && causa != 3) {
      this.formActualizaComplemento.get("kilometraje").setValidators([Validators.required, importeMayorACeroValidator()]);
      this.formActualizaComplemento.get("kilometraje").updateValueAndValidity();
    }

    if (causa != 3) {
      if (this.detalleComplementoSiniestro?.["ServicioTaller"] == "0") {
        this.formActualizaComplemento.get("tipoPerdida").setValidators(Validators.required);
        this.formActualizaComplemento.get("tipoPerdida").updateValueAndValidity();
      }

      if (this.detalleComplementoSiniestro?.["ServicioTaller"] == "0" && this.formActualizaComplemento.get("tipoPerdida").value == 2) {
        this.formActualizaComplemento.get("importe").setValidators([Validators.required, importeMayorACeroValidator()]);
        this.formActualizaComplemento.get("importe").updateValueAndValidity();
        this.formActualizaComplemento.get("corralonDestino").setValidators(Validators.required);
        this.formActualizaComplemento.get("corralonDestino").updateValueAndValidity();
      }
    } else {

    }
  }

  cambiosFormulario() {
    const subsSerie = this.formActualizaComplemento.get('serie')?.valueChanges.subscribe({
      next: (value) => {
        this.verificaSerieHTML = '';
        this.verificaSerieHTMLSa = null;
        // REVIEW: REVISAR
        // this.verificaNumeroSerie(value);
      },
    });
    const subsTipoUbicacion = this.formActualizaComplemento.get('tipoUbicacion')?.valueChanges.subscribe({
      next: (value) => {
        if (value == 3) {
          this.formActualizaComplemento.get("subUbicacion").setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formActualizaComplemento.get("subUbicacion").updateValueAndValidity();
        } else {
          this.formActualizaComplemento.get("subUbicacion").setValidators(null);
          this.formActualizaComplemento.get("subUbicacion").updateValueAndValidity();
        }
      },
    });
    const subsSubTipoUbicacion = this.formActualizaComplemento.get('subUbicacion')?.valueChanges.subscribe({
      next: (value) => {

        const causa = this.detalleSiniestroCompleto?.Siniestro[0].causa;
        if (value != 2 && causa == 3) {
          this.formActualizaComplemento.get("cp").setValidators(Validators.required);
          this.formActualizaComplemento.get("cp").updateValueAndValidity();

          this.formActualizaComplemento.get("numeroParticipantes").setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formActualizaComplemento.get("numeroParticipantes").updateValueAndValidity();
        } else {
          this.formActualizaComplemento.get("cp").setValidators(null);
          this.formActualizaComplemento.get("cp").updateValueAndValidity();

          this.formActualizaComplemento.get("numeroParticipantes").setValidators(null);
          this.formActualizaComplemento.get("numeroParticipantes").updateValueAndValidity();
        }
      },
    });
    const subTipoPerdida = this.formActualizaComplemento.get('tipoPerdida')?.valueChanges.subscribe({
      next: (value) => {
        const causa = this.detalleSiniestroCompleto?.Siniestro[0].causa;
        if (this.detalleComplementoSiniestro?.["ServicioTaller"] == "0" && value == 2 && causa != 3) {
          this.formActualizaComplemento.get("importe").setValidators([Validators.required, importeMayorACeroValidator()]);
          this.formActualizaComplemento.get("importe").updateValueAndValidity();
          this.formActualizaComplemento.get("corralonDestino").setValidators(Validators.required);
          this.formActualizaComplemento.get("corralonDestino").updateValueAndValidity();
        } else {
          this.formActualizaComplemento.get("importe").setValue(null);
          this.formActualizaComplemento.get("corralonDestino").setValue(null);
          this.formActualizaComplemento.get("importe").updateValueAndValidity();
          this.formActualizaComplemento.get("importe").setValidators(null);
          this.formActualizaComplemento.get("importe").updateValueAndValidity();
          this.formActualizaComplemento.get("corralonDestino").setValidators(null);
          this.formActualizaComplemento.get("corralonDestino").updateValueAndValidity();
        }

      },
    });
    const subsPais = this.formActualizaComplemento.get('pais')?.valueChanges.subscribe({
      next: (value) => {
        this.obtenerEstados(value);
      },
    });
    const subsEstado = this.formActualizaComplemento.get('estado')?.valueChanges.subscribe({
      next: (value) => {
        const { pais } = this.formActualizaComplemento.getRawValue();
        this.obtenerMunicipios(pais, value);
      },
    });
    const subsCP = this.formActualizaComplemento.get('cp')?.valueChanges.pipe(debounceTime(500)).subscribe({
      next: (value) => {
        this.obtenerDireccion(value);
      },
    });
    this.listaObservables.push(subsSerie);
    this.listaObservables.push(subsTipoUbicacion);
    this.listaObservables.push(subsPais);
    this.listaObservables.push(subsEstado);
    this.listaObservables.push(subsCP);
    this.listaObservables.push(subTipoPerdida);
    this.listaObservables.push(subsSubTipoUbicacion);
  }

  obtenerSubCausas(causa: number) {
    this.complementoService.consultaSubCausas({ causa }).subscribe({
      next: (value) => {
        this.subCausas = value.Resultado.SubCausas;
      },
    })
  }

  obtenerEstados(pais: number) {
    this.complementoService.consultaEstados({ pais }).subscribe({
      next: (value) => {
        this.estados = value.Resultado.Estados;
      },
    })
  }

  obtenerMunicipios(pais: number, estado: number) {
    this.complementoService.consultaMunicipios({ pais, estado }).subscribe({
      next: (value) => {
        this.municipios = value.Resultado.Municipios;
      },
    })
  }

  obtenerDireccion(codigoPostal: any) {
    if (codigoPostal?.length == 0 || codigoPostal == '0' || codigoPostal == null || codigoPostal == undefined) return;
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      cp: codigoPostal
    };
    this.complementoService.consultaDireccion(request).subscribe({
      next: (value: ResultApiResponse<ConsultaDireccionOutput>) => {
        this.formActualizaComplemento.patchValue({
          estado: value.Resultado.Direccion[0]?.cve_estado,
          colonia: value.Resultado.Direccion[0]?.colonia,
          municipio: value.Resultado.Direccion[0]?.cve_mpio,
        }, { emitEvent: false })
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  setFormulario() {
    let fechaDefault = "01/01/1901";
    let horaDefault = "00:00:00";

    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    const serieNormal = this.detalleSiniestroCompleto?.Siniestro[0].serie_normal == null ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].serie_normal;
    const causa = this.detalleSiniestroCompleto?.Siniestro[0].causa;

    if (serieNormal == 0 && perfilAdministrador == 0 && [3, 6].includes(causa)) {
      this.formActualizaComplemento.get("responsable").setValue(2);
    } else {
      this.formActualizaComplemento.patchValue({
        responsable: this.detalleComplementoSiniestro?.Responsable ? Number(this.detalleComplementoSiniestro?.Responsable) : null,
      });
    }

    this.formActualizaComplemento.patchValue({
      kilometraje: this.detalleComplementoSiniestro?.Kilometraje,
      serie: this.detalleSiniestroCompleto?.Siniestro[0].serie,
      edadConductor: this.detalleSiniestroCompleto?.Siniestro[0].edad == 0 ? null : this.detalleSiniestroCompleto?.Siniestro[0].edad,
      sexoConductor: this.detalleSiniestroCompleto?.Siniestro[0].sexo,
      email: this.detalleSiniestroCompleto?.Siniestro[0].email,
      estimacionDanos: 3, //REVIEW - ,
      corralonDestino: this.detalleSiniestroCompleto?.Siniestro[0].corralon_destino,
      preexistentes: this.detalleSiniestroCompleto?.Siniestro[0].serie_normal == 1 ? this.detalleSiniestroCompleto?.Siniestro[0].danos_preex == 0 ? 2 : 1 : 0,
      tipoUbicacion: this.detalleSiniestroCompleto?.Siniestro[0].tipo_ubicacion,
      subUbicacion: this.detalleSiniestroCompleto?.Siniestro[0].sub_tipo_ubicacion,
      tipoPerdida: this.detalleSiniestroCompleto?.Siniestro[0].serie_normal == 1 ? this.detalleSiniestroCompleto?.Siniestro[0].cve_perdida_total : 0,
      importe: this.detalleSiniestroCompleto?.Siniestro[0].serie_normal == 1 ? this.procesaCoberturas()?.importe : null,
      subCausa: causa == 3 ? this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.tipo_robo : this.detalleSiniestroCompleto?.Siniestro[0].sub_causa,

      inicioFechaAtencion: this.detalleSiniestroCompleto?.Siniestro[0].feciniatn == fechaDefault ? this.detalleSiniestroCompleto?.Siniestro[0].fecaviso : this.detalleSiniestroCompleto?.Siniestro[0].feciniatn,
      inicioHoraAtencion: this.detalleSiniestroCompleto?.Siniestro[0].horainiatn == horaDefault ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].horainiatn?.split(":")[0],
      inicioMinutoAtencion: this.detalleSiniestroCompleto?.Siniestro[0].horainiatn == horaDefault ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].horainiatn?.split(":")[1],

      finFechaAtencion: this.detalleSiniestroCompleto?.Siniestro[0].fecfinatn == fechaDefault ? this.detalleSiniestroCompleto?.Siniestro[0].fecaviso : this.detalleSiniestroCompleto?.Siniestro[0].fecfinatn,
      finHoraAtencion: this.detalleSiniestroCompleto?.Siniestro[0].horafinatn == horaDefault ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].horafinatn?.split(":")[0],
      finMinutoAtencion: this.detalleSiniestroCompleto?.Siniestro[0].horafinatn == horaDefault ? 0 : this.detalleSiniestroCompleto?.Siniestro[0].horafinatn?.split(":")[1],
    })

    this.formActualizaComplemento.get("pais").patchValue(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.cve_pais, { onlySelf: true });
    this.formActualizaComplemento.get("estado").patchValue(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.cve_estado || 0, { onlySelf: true });
    this.formActualizaComplemento.get("cp").patchValue(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.cp || 0, { onlySelf: true });

    setTimeout(() => {
      this.formActualizaComplemento.patchValue({
        colonia: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.colonia,
        municipio: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.cve_municipio,
        calle: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.calle,
        referencias: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.referencias,
        fechaRegistro: this.procesarFechas(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.fechareg) || moment().format("DD/MM/yyyy"),
        numeroParticipantes: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.num_participa,
        fechaRobo: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.fecha_aviso_concepto == null ? this.procesarFechas(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.fecha_aviso) : this.procesarFechas(this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.fecha_aviso_concepto),
        numeroActa: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.num_acta,
        ocra: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.status_ocra == 1 ? true : false,
        tipoRobo: this.detalleComplementoSiniestro?.["ComplementoRobo"]?.[0]?.tipo_robo,
      })
    }, 1000);

    if ([6, 4, 5].includes(this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa)) {
      this.formActualizaComplemento.get("subCausa").clearValidators();
      this.formActualizaComplemento.get("subCausa").updateValueAndValidity();
    }
  }

  procesaCoberturas() {
    let Cobertura = { cveCobertura: 0, sumaAsegurada: 0, deducible: 0, importe: "", valida: false };

    if (this.detalleComplementoSiniestro?.["Coberturas"] != undefined && this.detalleComplementoSiniestro?.["Coberturas"]?.length) {
      Cobertura = {
        cveCobertura: this.detalleComplementoSiniestro?.["Coberturas"][0].cve_coberturak,
        sumaAsegurada: this.detalleComplementoSiniestro?.["Coberturas"][0].suma_aseg,
        deducible: this.detalleComplementoSiniestro?.["Coberturas"][0].porc_deduc,
        importe: ((this.detalleComplementoSiniestro?.["Coberturas"][0].estimado?.replace(/[$,]/g, "") == null) ? ((this.detalleComplementoSiniestro?.["Coberturas"][0].orden_servicio == 1) ? 0 : "") : this.detalleComplementoSiniestro?.["Coberturas"][0].estimado?.replace(/[$,]/g, "")),
        valida: true
      };
    }
    return Cobertura;
  }

  procesarFechas(fecha: string) {
    if (!fecha) return null;
    const date = fecha.split("/");
    return `${date[2]}-${date[1]}-${date[0]}`
  }

  verificaNumeroSerie(serie: string) {
    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    const responsabilidad = this.detalleSiniestroCompleto?.Siniestro[0].respons_sini;
    const serieControl = this.formActualizaComplemento.get('serie');
    const serie_emision = this.detalleSiniestroCompleto?.Siniestro[0].serie_emision;
    const esSerieAdmin = this.detalleSiniestroCompleto?.Siniestro[0].serie_admin === 1;

    let validaSerie = true;
    let errorDigitos = 0;
    let htmlCode = '';

    const puedeValidar = perfilAdministrador === 0 ? !esSerieAdmin : false;

    if (puedeValidar) {
      this.cesvi.error_digitos = 0;
      htmlCode += `<span style="padding: 5px 5px 5px 5px; font-size: 10px;">`;
      for (let i = 0; i < serie_emision.length; i++) {
        const letra = serie[i] || '';
        const letraCorrecta = serie_emision[i];

        const color = (letra != letraCorrecta) ? 'cd0a0a' : '000000';
        const mostrarLetra = letra || '';

        if (letra != letraCorrecta) {
          errorDigitos++;
        }
        htmlCode += `<font color="#${color}" style="font-size: 10px;">${mostrarLetra}</font>`;
      }
      htmlCode += `</span>`;
      if (this.cesvi.intento == 0) {
        if (errorDigitos > 0) {
          this.cesvi.intento++;
          this.cesvi.error_digitos = errorDigitos;
          this.cesvi.estatus_cesvi = 0;
          this.cesvi.error_serie = 'La serie ingresada no corresponde a la registrada en emisión, favor de ingresarla nuevamente.';
          this.verificaSerieHTML = this.getTooltipContent();
          this.verificaSerieHTMLSa = this.sanitizer.bypassSecurityTrustHtml(this.verificaSerieHTML);
          serieControl?.setValue('');
          serieControl?.setErrors({ incorrecta: true });
          validaSerie = false;
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, this.cesvi.error_serie);
        }
      } else {
        if (errorDigitos > 0) {
          this.cesvi.error_digitos = errorDigitos;
          serieControl?.setErrors({ incorrecta: true });
          this.procesosComplementoService.alertaGeneralComplemento(
            'Aviso',
            '',
            'warning',
            false,
            true,
            'Contactar a cabina ya que la serie ingresada no corresponde a la registrada en emisión.<br><br><b>Nota: </b><br><br><b>El registro "NO" podrá guardarse hasta no ingresar la serie correcta.</b>'
          );
          validaSerie = false;
        } else {
          serieControl?.setErrors(null);
        }
      }
    }

    this.verificaSerieHTML = htmlCode;
    this.verificaSerieHTMLSa = this.sanitizer.bypassSecurityTrustHtml(htmlCode);
    return validaSerie;
  }

  guardarComplemento() {
    if (this.serieInvalida) {
      this.formActualizaComplemento.get('serie')?.setErrors(null, { emitEvent: false });
      this.formActualizaComplemento.get('serie')?.updateValueAndValidity();
      this.serieInvalida = false;
    }

    if (!this.formActualizaComplemento.valid) {
      console.log(this.formActualizaComplemento)
      this.procesosComplementoService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, "Debes capturar los campos requeridos");
      return this.formActualizaComplemento.markAllAsTouched();
    }

    if (this.verificaNumeroSerie(this.formActualizaComplemento.get('serie').value)) {
      this.limpiarNotificacionSerie();
      const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
      const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
      let serieNormal = ((this.detalleSiniestroCompleto.Siniestro[0].serie_normal == null) ? 0 : this.detalleSiniestroCompleto.Siniestro[0].serie_normal);
      const request = {
        sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
        linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
        producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
        poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
        endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
        a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
        no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
        cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
        cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
        inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
        num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
        alarma: this.detalleSiniestroCompleto.Siniestro[0].alarma,
        moneda: siniestroFormateado.moneda,
        ramo: siniestroFormateado.ramo,
        sramo: siniestroFormateado.sramo,
        oficina: siniestroFormateado.oficina,
        consecutivo: siniestroFormateado.consecutivo,
        anio: siniestroFormateado.anio,
        modelo: this.detalleSiniestroCompleto.Siniestro[0].modelo,
        vehiculo: this.detalleSiniestroCompleto.Siniestro[0].vehiculo,
        responsable: this.formActualizaComplemento.getRawValue()?.responsable,
        subCausa: this.formActualizaComplemento.getRawValue()?.subCausa,
        serie: this.formActualizaComplemento.getRawValue()?.serie,
        Kilometraje: this.formActualizaComplemento.getRawValue()?.kilometraje,
        edad: this.formActualizaComplemento.getRawValue()?.edadConductor,
        tipoPerdida: this.formActualizaComplemento.getRawValue()?.tipoPerdida,
        claveTipoPerdida: this.detalleSiniestroCompleto.Siniestro[0].cve_perdida_total,
        sexo: this.formActualizaComplemento.getRawValue()?.sexoConductor,
        danosPreexistentes: this.formActualizaComplemento.getRawValue()?.preexistentes,
        correoElectronico: this.formActualizaComplemento.getRawValue()?.email,
        estimacion: this.formActualizaComplemento.getRawValue()?.estimacionDanos,
        cantidadDigitosIncorrectos: this.cesvi.error_digitos,
        status_mbs: this.detalleSiniestroCompleto.FechasAtencion?.length ? 0 : this.detalleSiniestroCompleto.Siniestro[0].status_mbs,
        inicioFechaAtencion: this.formActualizaComplemento.getRawValue()?.inicioFechaAtencion,
        inicioHoraAtencion: `${this.formActualizaComplemento.getRawValue()?.inicioHoraAtencion}:${this.formActualizaComplemento.getRawValue()?.inicioMinutoAtencion}:${this.detalleSiniestroCompleto?.Siniestro[0].horainiatn.split(":")[2]}`,
        finFechaAtencion: this.formActualizaComplemento.getRawValue()?.finFechaAtencion,
        finHoraAtencion: `${this.formActualizaComplemento.getRawValue()?.finHoraAtencion}:${this.formActualizaComplemento.getRawValue()?.finMinutoAtencion}:${this.detalleSiniestroCompleto?.Siniestro[0].horafinatn.split(":")[2]}`,
        fechaAviso: this.detalleSiniestroCompleto.Siniestro[0].fecaviso,
        horaAviso: this.detalleSiniestroCompleto.Siniestro[0].horaviso,
        tipoUbicacion: this.formActualizaComplemento.getRawValue()?.tipoUbicacion,
        perfilAdministrador: perfilAdministrador,
        serieAdministrador: this.detalleSiniestroCompleto.Siniestro[0].serie_admin ?? "0",
        camposAdministrador: perfilAdministrador == 1 ? 1 : serieNormal,
        causa: this.detalleSiniestroCompleto.Siniestro[0].causa,
        pais: this.formActualizaComplemento.getRawValue()?.pais,
        estado: this.formActualizaComplemento.getRawValue()?.estado,
        cp: this.formActualizaComplemento.getRawValue()?.cp,
        colonia: this.formActualizaComplemento.getRawValue()?.colonia,
        municipio: this.formActualizaComplemento.getRawValue()?.municipio,
        calle: this.formActualizaComplemento.getRawValue()?.calle,
        referencias: this.formActualizaComplemento.getRawValue()?.referencias,
        fechaRegistro: this.formActualizaComplemento.getRawValue()?.fechaRegistro,
        fechaRobo: this.formActualizaComplemento.getRawValue()?.fechaRobo,
        tipoRobo: this.formActualizaComplemento.getRawValue()?.tipoRobo,
        participantes: this.formActualizaComplemento.getRawValue()?.numeroParticipantes,
        numeroActa: this.formActualizaComplemento.getRawValue()?.numeroActa,
        ocra: this.formActualizaComplemento.getRawValue()?.ocra,
        fechaOcurrido: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
        importe: this.formActualizaComplemento.getRawValue()?.importe?.replace(/[$,]/g, "") ?? "",
        cadenaCoberturas: `${this.procesosComplementoService.generarCadenaCoberturasComplemento(this.formActualizaComplemento.getRawValue()?.importe, this.coberturasComplemento, this.detalleComplementoSiniestro, this.detalleSiniestroCompleto)}`,
        subTipoUbicacion: this.formActualizaComplemento.getRawValue()?.subUbicacion,
        corralonDestino: this.formActualizaComplemento.getRawValue()?.corralonDestino ?? "",
      }
      this.store.dispatch(ActivarLoadingAction());
      this.complementoService.actualizaComplemento(request).subscribe({
        next: (value) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.configuraFormulario();
          if (value.Resultado != null && value.Exito && value.Mensaje == null) {
            if (value.Resultado?.error_serie?.length && this.cesvi.estatus_cesvi != 0) {
              this.procesosComplementoService.alertaGeneralComplemento('Aviso', "", 'success', false, true, `${value.MensajeSistema}<br> <b>Nota: Se detectaron algunos errores en la serie. </b>`);
              this.cesvi.error_serie = value.Resultado?.error_serie;
              this.cesvi.estatus_cesvi = Number(value.Resultado.estatus_cesvi);
              this.mostrarNotificacionSerie();
              return;
            }
            this.procesosComplementoService.alertaGeneralComplemento('Guardado', `La información del complemento se actualizó correctamente`, 'success', false, true);
            this.eventosActualizaComplemento.emit({ nombre: 'ACTUALIZAR_COMPLEMENTO', valor: true });
            this.cesvi.error_serie = value.Resultado?.error_serie;
            this.cesvi.estatus_cesvi = Number(value.Resultado.estatus_cesvi);
            this.mostrarNotificacionSerie(true);
          } else {
            if (value.Resultado?.error_serie?.length == 0 && this.cesvi.estatus_cesvi != 0) return this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se actualizó la información del complemento. ${value?.Mensaje || value?.MensajeSistema || ''}`, 'warning', false, true);
            if (!value.Exito && value.Resultado?.error_serie?.length) {
              this.cesvi.error_serie = value.Resultado?.error_serie;
              this.cesvi.estatus_cesvi = Number(value.Resultado.estatus_cesvi);
              this.serieInvalida = true;
              this.mostrarNotificacionSerie();
              return this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se actualizó la información del complemento. ${value?.Mensaje || value?.MensajeSistema || ''}`, 'warning', false, true);
            }
            if (!value.Exito) return this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se actualizó la información del complemento. ${value?.Mensaje || value?.MensajeSistema || ''}`, 'warning', false, true);
            this.procesosComplementoService.alertaGeneralComplemento('Guardado', `La información se actualizó correctamente`, 'success', false, true);
            this.eventosActualizaComplemento.emit({ nombre: 'ACTUALIZAR_COMPLEMENTO', valor: true });
          }
        },
        error: (err) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos actualizar los datos del complemento.' }));
        },
      })
    }
  }

  mostrarNotificacionSerie(limpiar: boolean = false) {
    const tool = this.getTooltipContent();
    console.log(tool)
    this.verificaSerieHTML = tool;
    this.verificaSerieHTMLSa = this.sanitizer.bypassSecurityTrustHtml(tool);
    this.formActualizaComplemento.get('serie')?.markAsTouched();
    this.formActualizaComplemento.get('serie')?.setErrors({ incorrecta: true });
    if (limpiar) {
      setTimeout(() => {
        this.limpiarNotificacionSerie();
      }, 500);
    }
  }

  limpiarNotificacionSerie() {
    window.scrollTo(0, 0);
    this.verificaSerieHTML = "";
    this.verificaSerieHTMLSa = null;
    this.cesvi.estatus_cesvi = 0;
    this.cesvi.error_serie = "";
    this.formActualizaComplemento.get('serie')?.setErrors(null, { emitEvent: false });
  }

  getTooltipContent(): string {
    if (this.cesvi.estatus_cesvi != 0) return '<small style="font-weight : bold; font-size: 10px;">Serie correcta</small>';
    if (this.cesvi.error_serie == null) return;
    const datos = this.cesvi.error_serie.includes("|") ? this.cesvi.error_serie.split('|') : [this.cesvi.error_serie];
    let html = '<ul style="list-style-type: circle; padding: 5px 0px 5px 5px;">';

    datos.forEach(dato => {
      if (dato.includes(')')) {
        dato.split(')').forEach(sub => {
          if (sub.trim()) html += `<li style="font-weight : bold; color:red; font-size: 10px;">${sub})</li>`;
        });
      } else if (dato.trim()) {
        html += `<li style="font-weight : bold; color:red; font-size: 10px;">${dato}</li>`;
      }
    });

    html += '</ul>';
    return html;
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }

  closeMenu(trigger: MatMenuTrigger) {
    trigger.closeMenu();
  }

  procesarVariablesFechas(perfilAdministrador: number, fechasAtencion: FechasAtencion[]) {

    Object.keys(this.banderasFechas).forEach(k => this.banderasFechas[k] = false);

    let contadorInicio = 0;
    let contadorTermino = 0;

    fechasAtencion.forEach(f => {
      switch (f.alpha) {
        case 'feciniatn':
          this.banderasFechas.fechaInicio = true;
          if (perfilAdministrador == 0) {
            this.formActualizaComplemento.get("inicioFechaAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("inicioFechaAtencion").updateValueAndValidity();
          }
          contadorInicio++;
          break;

        case 'horainiatn':
          this.banderasFechas.mostrarHoraInicio = true;
          if (perfilAdministrador == 0) {
            this.formActualizaComplemento.get("inicioHoraAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("inicioHoraAtencion").updateValueAndValidity();
            this.formActualizaComplemento.get("inicioMinutoAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("inicioMinutoAtencion").updateValueAndValidity();
          }
          contadorInicio++;
          break;

        case 'fecfinatn':
          this.banderasFechas.fechaFin = true;
          if (perfilAdministrador == 0) {
            this.formActualizaComplemento.get("finFechaAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("finFechaAtencion").updateValueAndValidity();
          }
          contadorTermino++;
          break;

        case 'horafinatn':
          this.banderasFechas.mostrarHoraTermino = true;
          if (perfilAdministrador == 0) {
            this.formActualizaComplemento.get("finHoraAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("finHoraAtencion").updateValueAndValidity();
            this.formActualizaComplemento.get("finMinutoAtencion").setValidators([Validators.required]);
            this.formActualizaComplemento.get("finMinutoAtencion").updateValueAndValidity();
          }
          contadorTermino++;
          break;
      }
    });
    this.mostrarSeccionInicio = contadorInicio > 0;
    this.mostrarSeccionTermino = contadorTermino > 0;
  }
}
